import _slicedToArray from "/workspace/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/workspace/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/workspace/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { ethers } from 'ethers';
import { erc20ABI, forwarderAbi, forwarderFeeAbi } from './abis';
import { isFullMethodSignature } from './app';
export function createDirectTransaction(_x, _x2, _x3, _x4) {
  return _createDirectTransaction.apply(this, arguments);
}

function _createDirectTransaction() {
  _createDirectTransaction = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(sender, destination, methodAbiFragment, params) {
    var transactionOptions, options, ethersInterface;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            transactionOptions = {}; // If an extra parameter has been provided, it is the transaction options if it is an object

            if (methodAbiFragment.inputs.length + 1 === params.length && typeof params[params.length - 1] === 'object') {
              options = params.pop();
              transactionOptions = _objectSpread({}, transactionOptions, {}, options);
            }

            ethersInterface = new ethers.utils.Interface([methodAbiFragment]); // The direct transaction we eventually want to perform

            return _context.abrupt("return", _objectSpread({}, transactionOptions, {
              from: sender,
              to: destination,
              data: ethersInterface.encodeFunctionData(ethers.utils.FunctionFragment.from(methodAbiFragment), params)
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _createDirectTransaction.apply(this, arguments);
}

export function createDirectTransactionForApp(_x5, _x6, _x7, _x8) {
  return _createDirectTransactionForApp.apply(this, arguments);
}

function _createDirectTransactionForApp() {
  _createDirectTransactionForApp = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(sender, app, methodSignature, params) {
    var destination, methodAbiFragment;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (app) {
              _context2.next = 2;
              break;
            }

            throw new Error("Could not create transaction due to missing app artifact");

          case 2:
            destination = app.address;

            if (app.abi) {
              _context2.next = 5;
              break;
            }

            throw new Error("No ABI specified in artifact for ".concat(destination));

          case 5:
            methodAbiFragment = app.abi.find(function (method) {
              // If the full signature isn't given, just find the first overload declared
              if (!isFullMethodSignature(methodSignature)) {
                return method.name === methodSignature;
              } // Fallback functions don't have inputs in the ABI


              var currentParameterTypes = Array.isArray(method.inputs) ? method.inputs.map(function (_ref) {
                var type = _ref.type;
                return type;
              }) : [];
              var currentMethodSignature = "".concat(method.name, "(").concat(currentParameterTypes.join(','), ")");
              return currentMethodSignature === methodSignature;
            });

            if (methodAbiFragment) {
              _context2.next = 8;
              break;
            }

            throw new Error("".concat(methodSignature, " not found on ABI for ").concat(destination));

          case 8:
            return _context2.abrupt("return", createDirectTransaction(sender, destination, methodAbiFragment, params));

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _createDirectTransactionForApp.apply(this, arguments);
}

export function createForwarderTransactionBuilder(sender, directTransaction) {
  var forwarder = new ethers.utils.Interface(forwarderAbi);
  return function (forwarderAddress, script) {
    return _objectSpread({}, directTransaction, {
      from: sender,
      to: forwarderAddress,
      data: forwarder.encodeFunctionData('forward', [script])
    });
  };
}
export function buildPretransaction(_x9, _x10) {
  return _buildPretransaction.apply(this, arguments);
}

function _buildPretransaction() {
  _buildPretransaction = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(transaction, provider) {
    var from, to, _transaction$token, tokenAddress, tokenValue, spender, approveSpender, tokenContract, balance, tokenValueBN, allowance, allowanceBN, erc20;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            // Token allowance pretransactionn
            from = transaction.from, to = transaction.to, _transaction$token = transaction.token, tokenAddress = _transaction$token.address, tokenValue = _transaction$token.value, spender = _transaction$token.spender; // Approve the transaction destination unless an spender is passed to approve a different contract

            approveSpender = spender || to;
            tokenContract = new ethers.Contract(tokenAddress, erc20ABI, provider);
            _context3.next = 5;
            return tokenContract.balanceOf(from);

          case 5:
            balance = _context3.sent;
            tokenValueBN = BigInt(tokenValue);

            if (!(BigInt(balance) < tokenValueBN)) {
              _context3.next = 9;
              break;
            }

            throw new Error("Balance too low. ".concat(from, " balance of ").concat(tokenAddress, " token is ").concat(balance, " (attempting to send ").concat(tokenValue, ")"));

          case 9:
            _context3.next = 11;
            return tokenContract.allowance(from, approveSpender);

          case 11:
            allowance = _context3.sent;
            allowanceBN = BigInt(allowance); // If allowance is already greater than or equal to amount, there is no need to do an approve transaction

            if (!(allowanceBN < tokenValueBN)) {
              _context3.next = 17;
              break;
            }

            if (allowanceBN > BigInt(0)) {
              // TODO: Actually handle existing approvals (some tokens fail when the current allowance is not 0)
              console.warn("".concat(from, " already approved ").concat(approveSpender, ". In some tokens, approval will fail unless the allowance is reset to 0 before re-approving again."));
            }

            erc20 = new ethers.utils.Interface(erc20ABI);
            return _context3.abrupt("return", {
              from: from,
              to: tokenAddress,
              data: erc20.encodeFunctionData('approve', [approveSpender, tokenValue])
            });

          case 17:
            return _context3.abrupt("return", undefined);

          case 18:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _buildPretransaction.apply(this, arguments);
}

export function buildForwardingFeePretransaction(_x11, _x12) {
  return _buildForwardingFeePretransaction.apply(this, arguments);
}

function _buildForwardingFeePretransaction() {
  _buildForwardingFeePretransaction = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(forwardingTransaction, provider) {
    var forwarderAddress, from, forwarderFee, feeDetails, overrides, _ref2, _ref3, tokenAddress, amount, forwardingTxWithTokenData;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            forwarderAddress = forwardingTransaction.to, from = forwardingTransaction.from;
            forwarderFee = new ethers.Contract(forwarderAddress, forwarderFeeAbi, provider);
            feeDetails = {
              amount: BigInt(0),
              tokenAddress: ''
            };
            _context4.prev = 3;
            overrides = {
              from: from
            }; // Passing the EOA as `msg.sender` to the forwardFee call is useful for use cases where the fee differs relative to the account

            _context4.next = 7;
            return forwarderFee.forwardFee(overrides);

          case 7:
            _ref2 = _context4.sent;
            _ref3 = _slicedToArray(_ref2, 2);
            tokenAddress = _ref3[0];
            amount = _ref3[1];
            // forwardFee() returns (address, uint256)
            feeDetails.tokenAddress = tokenAddress;
            feeDetails.amount = BigInt(amount);
            _context4.next = 17;
            break;

          case 15:
            _context4.prev = 15;
            _context4.t0 = _context4["catch"](3);

          case 17:
            if (!(feeDetails.tokenAddress && feeDetails.amount > BigInt(0))) {
              _context4.next = 20;
              break;
            }

            // Needs a token approval pretransaction
            forwardingTxWithTokenData = _objectSpread({}, forwardingTransaction, {
              token: {
                address: feeDetails.tokenAddress,
                spender: forwarderAddress,
                value: feeDetails.amount.toString()
              }
            });
            return _context4.abrupt("return", buildPretransaction(forwardingTxWithTokenData, provider));

          case 20:
            return _context4.abrupt("return", undefined);

          case 21:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[3, 15]]);
  }));
  return _buildForwardingFeePretransaction.apply(this, arguments);
}